import Vue from 'vue'
import Vuex from 'vuex'
import {login,noteDataLogin,noteLogin,register} from "@/api/home"
import router from '@/router'


// import user from './modules/user'
import getters from './getters'
// import user from './modules/user'

Vue.use(Vuex)



const store = new Vuex.Store({

  state: {
    token:""
  },
  mutations: {
    //密码登录
    LOGIN:(state,data)=>{
      let ct = new Vue
      const loading = ct.$loading({
        lock: true,
        text: '登录中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      login(data).then(res=>{
        if(res.code==0){
          loading.close();
          state.token = res.data.token
          localStorage.setItem('token', res.data.token);
          localStorage.setItem("name",ct.getAesString(res.data))
          router.push("/")
        }else{
          setTimeout(() => {
            loading.close();
            ct.$message.error(res.msg);
          }, 1000);
        }

      })
    },
    //验证码登录
    AUTHLOGIN:(state,data)=>{
      
      let ct = new Vue
      const loading = ct.$loading({
        lock: true,
        text: '登录中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      noteLogin(data).then(res=>{
        if(res.code==0){
          loading.close();
          state.token = res.data.token
          localStorage.setItem('token', res.data.token);
          localStorage.setItem("name",ct.getAesString(res.data))
          router.push("/")
        }else{
          setTimeout(() => {
            loading.close();
            ct.$message.error(res.msg);
          }, 1000);
        }
      })
    },
    //发送验证码
    AUTHCODE:(state,data)=>{
      noteDataLogin(data).then(res=>{
        console.log(res);
      })
    },
    //注册
    REGISTER:(state,data)=>{
      let ct = new Vue
      const loading = ct.$loading({
        lock: true,
        text: '注册中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      register(data).then(res=>{
        if(res.code==0){
          loading.close();
          // router.push("/")
          location.reload()
        }else{
          setTimeout(() => {
            loading.close();
            ct.$message.error(res.msg);
          }, 1000);
        }
      })
    }
  },




  actions: {
    //登录
    login({commit},data){
      console.log(data);
      commit('LOGIN',data)
    },
    //验证码登录
    authLogin({commit},data){
      commit('AUTHLOGIN',data)
    },
    //发送验证码
    authCode({commit},data){
      commit("AUTHCODE",data)
    },
    //注册
    register({commit},data){
      commit("REGISTER",data)
    }
  },


  modules: {
    
  },
  getters
})


export default store


